/**
 * src/util/bluebird
 */
ISMDSPlugin.define('promise',[], function () {
  return ICE.bluebird;
});

